export const PROVIDER_SELECTION = 'PROVIDER_SELECTION'
export const CLEAR_PROVIDER_SELECTION = 'CLEAR_PROVIDER_SELECTION'
export const USER_CREATED = 'USER_CREATED'
export const CLIENT_CREATED = 'CLIENT_CREATED'